import CryptoJS from 'crypto-js'

const SECRET_KEYS = {
  GIH: 'jkHh*&(^789',
  'Berlin School of Business and Innovation': 'jkHh*&(^789',
}

const SECRET_KEYS_PRODUCTION = {
  GIH: 'hkJl56fghfk56J15h796DjhHKJ',
  'Berlin School of Business and Innovation': 'hkJl56fghfk56J15h796DjhHKJ',
}

export function generateSignedData(dataObject, brand) {
  try {
    const secretKey =
      process.env.REACT_APP_STAGE === 'prod'
        ? SECRET_KEYS_PRODUCTION[brand]
        : SECRET_KEYS[brand]
    // Convert data object to JSON string
    const dataJson = JSON.stringify(dataObject)

    // Base64 encode the JSON data using browser's btoa
    const base64EncodedData = btoa(dataJson)

    // Generate HMAC-SHA256 signature using crypto-js
    const signature = CryptoJS.HmacSHA256(base64EncodedData, secretKey)

    // Base64 encode the signature
    const base64EncodedSignature = signature.toString(CryptoJS.enc.Base64)

    // Concatenate signature and data with a period
    const signedData = `${base64EncodedSignature}.${base64EncodedData}`

    return signedData
  } catch (error) {
    throw new Error(`Failed to generate signed data: ${error.message}`)
  }
}

export function validateSignedData(signedData, brand) {
  try {
    const secretKey = SECRET_KEYS[brand]
    // Split the signedData into signature and data parts
    const [base64EncodedSignature, base64EncodedData] = signedData.split('.')

    if (!base64EncodedSignature || !base64EncodedData) {
      throw new Error('Invalid signed data format')
    }

    // Recalculate the signature using the same logic as in the generate function
    const expectedSignature = CryptoJS.HmacSHA256(
      base64EncodedData,
      secretKey,
    ).toString(CryptoJS.enc.Base64)

    // Constant time comparison to prevent timing attacks
    const isValid = expectedSignature === base64EncodedSignature

    if (!isValid) {
      throw new Error('Signature mismatch. Data may have been tampered with.')
    }

    // Decode and parse the original data
    const jsonData = atob(base64EncodedData)
    const dataObject = JSON.parse(jsonData)

    return {
      valid: true,
      data: dataObject,
    }
  } catch (error) {
    return {
      valid: false,
      error: `Failed to validate signed data: ${error.message}`,
    }
  }
}
